import { Icon } from "@iconify/react";
const skillIconSize = "4.5rem";
type Skill = {
  name: string;
  icon: string;
  color?: string;
};

export function SkillCard({ name, ...props }: Skill): JSX.Element {
  return (
    <div className="skill-item">
      <Icon
        className="skill-icon"
        height={skillIconSize}
        width={skillIconSize}
        {...props}
      />
      <h4 className="skill-title">{name}</h4>
    </div>
  );
}
